export default __webpack_public_path__ + "static/media/tg_logo.b26926a7.svg";